import axios from 'axios';
import * as PIXI from 'pixi.js-legacy';
import { CheckUrlFromStorage, getProxyUrl } from './Utils';

function Load(src, loadedTextures, id) {
  var uniqueName = GetUniqueName(src, id);
  if (!PIXI.utils.TextureCache[uniqueName]) {
    var video = document.createElement('video');
    video.autoPlay = false;
    video.loop = src.loop_video;
    video.muted = src.mute;
    video.crossOrigin = 'anonymous';
    video.preload = 'auto';
    var vid = '';
    if (src.start) {
      video.currentTime = src.start;
      let url = src.url;
      // url = src.url + '#t=' + src.start;
      // if(src.end && src.end !==''){
      //     url=url+','+src.end;
      // }

      if (!(CheckUrlFromStorage(url) || url.includes('VIDEOBLOCKS') || url.includes('gettyimages.com'))) {
        url =  getProxyUrl(url);
      } else {
        if (url.toLowerCase().startsWith('http') && !url.includes('VIDEOBLOCKS') && !url.includes('gettyimages.com')) {
          let parsedUrl = new URL(url);
          parsedUrl.searchParams.append('source', 'preview');
          url = parsedUrl.toString();
          if (url.includes('/videos/transcription/') || url.includes('/samples/videos/')) {
            let updatedurl = '';
            let indexDot = url.lastIndexOf('.');
            updatedurl = url.substr(0, indexDot) + '_480p' + url.substr(indexDot);
            axios
              .head(updatedurl)
              .then(response => {
                if (response.status === 200) {
                  video.src = updatedurl;
                } else {
                  video.src = url;
                }
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              })
              .catch(() => {
                video.src = url;
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              });
          }
        } else if (url.includes('VIDEOBLOCKS') || url.includes('gettyimages.com')) {
          if (src.resource_id && src.resource_id !== '') {
            let parsedUrl = new URL(url);
            parsedUrl.searchParams.append('xyzabcqw', src.sessionId);
            url = parsedUrl.toString();
            axios
              .get(url, { responseType: 'blob' })
              .then(response => {
                url = URL.createObjectURL(response.data);
                video.src = url;
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              })
              .catch(() => {
                video.src = url;
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              });
          }
        }
      }
      if (
        !url.includes('VIDEOBLOCKS') &&
        !url.includes('gettyimages.com') &&
        !url.includes('/videos/transcription/') &&
        !url.includes('/samples/videos/')
      ) {
        video.src = url;
        video.load();
        vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
      }
    } else {
      let url = src.url;
      if (!(CheckUrlFromStorage(url) || url.includes('VIDEOBLOCKS') || url.includes('gettyimages.com'))) {
        url =  getProxyUrl(url);
      } else {
        if (
          (url.toLowerCase().startsWith('http') ||
            url.includes('/videos/transcription/') ||
            url.includes('/samples/videos/')) &&
          !url.includes('VIDEOBLOCKS') &&
          !url.includes('gettyimages')
        ) {
          let parsedUrl = new URL(url);
          parsedUrl.searchParams.append('source', 'preview');
          url = parsedUrl.toString();
          if (url.includes('/videos/transcription/') || url.includes('/samples/videos/')) {
            let updatedurl = '';
            let indexDot = url.lastIndexOf('.');
            updatedurl = url.substr(0, indexDot) + '_480p' + url.substr(indexDot);
            axios
              .head(updatedurl)
              .then(response => {
                if (response.status === 200) {
                  video.src = updatedurl;
                } else {
                  video.src = url;
                }
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              })
              .catch(() => {
                video.src = url;
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              });
          }
        } else if (url.includes('VIDEOBLOCKS') || url.includes('gettyimages.com')) {
          if (src.resource_id && src.resource_id != '') {
            let parsedUrl = new URL(url);
            parsedUrl.searchParams.append('xyzabcqw', src.sessionId);
            url = parsedUrl.toString();
            axios
              .get(url, { responseType: 'blob' })
              .then(response => {
                url = URL.createObjectURL(response.data);
                video.src = url;
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              })
              .catch(() => {
                video.src = url;
                video.load();
                let vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
                var texture = PIXI.Texture.from(vid);
                texture.baseTexture.resource.autoPlay = false;
                loadedTextures.push(texture);
                PIXI.Texture.removeFromCache(uniqueName);
                PIXI.Texture.addToCache(texture, uniqueName);
              });
          }
        }
      }
      if (
        !url.includes('VIDEOBLOCKS') &&
        !url.includes('gettyimages.com') &&
        !url.includes('/videos/transcription/') &&
        !url.includes('/samples/videos/')
      ) {
        video.src = url;
        video.load();
        vid = new PIXI.VideoResource(video, { crossorigin: true, preload: 'auto', autoLoad: true });
      }
    }
    //vid.load();
    if (vid) {
      var texture = PIXI.Texture.from(vid);
      texture.baseTexture.resource.autoPlay = false;
      loadedTextures.push(texture);
      PIXI.Texture.removeFromCache(uniqueName);
      PIXI.Texture.addToCache(texture, uniqueName);
    }
  }
}

function GetUniqueName(src, id) {
  let name = '';
  if (src.asset_id) {
    name = src.start ? src.asset_id + src.start : src.asset_id;
    name = name + (src.resource_id ? src.resource_id : '');
  } else {
    name = src.start ? src.url + src.start : src.url;
    name = name + (src.resource_id ? src.resource_id : '');
  }
  name = id ? name + id : name;
  return name;
}

function CheckIfVideoTextureValid(src) {
  var Texture = PIXI.utils.TextureCache[GetUniqueName(src)];

  return Texture && Texture.valid && Texture.baseTexture.resource.source.readyState >= 2 ? true : false;
}
function GetTexture(src) {
  return PIXI.utils.TextureCache[GetUniqueName(src)];
}

function RemoveTexture(src) {
  var uniqueName = GetUniqueName(src);
  PIXI.Texture.removeFromCache(uniqueName);
}
export default { Load, GetUniqueName, CheckIfVideoTextureValid, GetTexture, RemoveTexture };
